import MemberImport from './member_import.vue'
import ShopImport from './modules/shop_import.vue'
import TableImport from './modules/table_import.vue'

export default {
    name: 'memberImport',
    path: 'memberImport',
    component: MemberImport,
    children: [
        {
            path: '',
            redirect:  'shopImport'  // 默认到表格导入
        },
        {
            path: 'shopImport',
            component: ShopImport
        },
        {
            path: 'tableImport',
            component: TableImport
        }
    ]
}
